<template>
  <div class="b-tabs-menu b-tabs-menu_main b-tabs-menu_center">
    <BundlePoolTags :number="this.number" />
  </div>
  <div class="b-tabs-block">
    <BundlePoolSlider :number="this.number" />
  </div>
</template>

<script>
import BundlePoolTags from "./BundlePoolTags.vue";
import BundlePoolSlider from "./BundlePoolSlider.vue";

export default {
  name: "BundlePool",
  components: { BundlePoolTags, BundlePoolSlider },
  props: {
    number: Number,
  },
};
</script>
